import regEx from 'utils/global/regEx'

const camelToSnakeCase = (str: string) =>
  str.replace(regEx.uppercaseLetter, (letter) => `_${letter.toLowerCase()}`)

export const convertKeysToSnakeCase = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  obj: Record<string, any>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Record<string, any> => {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToSnakeCase(item))
  } else if (obj !== null && typeof obj === 'object') {
    return Object.entries(obj).reduce(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (acc: Record<string, any>, [key, value]) => {
        const newKey = camelToSnakeCase(key)
        acc[newKey] = convertKeysToSnakeCase(value)
        return acc
      },
      {},
    )
  }
  return obj
}

export default convertKeysToSnakeCase
